import React from 'react';
import PropTypes from 'prop-types';

const HockeyPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M18.443 28.524c-3.025 0-5.477-.91-5.477-2.027V23.66c0-1.121 2.452-2.026 5.477-2.026 3.025 0 5.476.909 5.476 2.026v2.838c.004 1.118-2.451 2.027-5.476 2.027zm0-5.68c2.128 0 3.853.543 3.853 1.215 0 .671-1.72 1.219-3.853 1.219-2.129 0-3.854-.544-3.854-1.215s1.725-1.22 3.854-1.22zm6.696-19.476c.582-1.181 3.13.803 2.838 1.47-.28.641-4.534 9.997-4.925 10.898-.042.106-.395.599-.7 1.062-.744 1.228-1.505 2.336-2.333 3.709H18.31c1.109-1.853 2.706-3.841 3.254-5.018-.259-.123-.73-.484-.973-.008-1.24 1.988-3.093 4.397-4.376 4.529-1.657.17-6.832-2.367-8.858-3.382-2.027-1.016-2.804 1.117-3.042 1.759-1.118 2.366-.714 3.48-.34 3.683 2.677 1.56 5.366 2.307 7.788 3.072v1.852c-4.19-.98-7.087-2.77-8.128-3.339-2.4-1.321-1.69-3.314-.811-6.088 1.074-3.4 3.573-2.962 4.486-2.588 1.657.68 6.879 3.4 8.502 3.4 1.623 0 4.057-4.904 4.46-5.681a.459.459 0 0 1 .111-.145c1.487-2.846 4.27-8.2 4.755-9.185z"
    />
  );
};

HockeyPath.propTypes = {
  fill: PropTypes.string,
};

export default HockeyPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/hockey.jsx